export type Proximity = {
  lat: number
  lng: number
  radius: number
  label: string
}

const SEPARATOR = '|'

export const encodeProximity = ({ lat, lng, radius, label }: Proximity) =>
  [lat, lng, radius, label].join(SEPARATOR)

export const parseProximity = (value: string | undefined): Proximity | null => {
  if (!value) return null
  const [lat, lng, radius, ...label] = value.split(SEPARATOR)
  const parsed = {
    lat: Number(lat),
    lng: Number(lng),
    radius: Number(radius),
    label: label.join(SEPARATOR)
  }
  if (
    !Number.isFinite(parsed.lat) ||
    !Number.isFinite(parsed.lng) ||
    !Number.isFinite(parsed.radius)
  ) {
    return null
  }
  return parsed
}
